<template>
  <div class="table_card__info">
    <v-layout row wrap>
      <v-flex xs12>
        <span class="table_card__info--label">Banner</span>
        <div class="trainers__form--photo_container">
          <label
            for="trainerPhoto"
            class="faccess_button buttom_shadow px-5">Examinar</label>
          <input
            id="trainerPhoto"
            type="file"
            accept="image/x-png,image/gif,image/jpeg"
            @change="onFileChange"
            name="image">
        </div>
        <div class="" v-if="url_change">
          <img :src="url" alt="">
          <button
            class="faccess_button px-5"
            @click="createBanner()">
            Crear
          </button>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  data(){
    return{
      banner:{
        attributes:{
          image:'',
          state: "ACTIVE",
          company_id: this.getCompany().id
        }
      },
      url:'',
      url_change: false
    }
  },
  watch:{
    url(){
      this.url_change = true
    }
  },
  mounted(){
    console.log("BANNER!!!!!!!!!!!!!!!!!!!!");
    console.log(this.banner);
  },
  methods:{
    createBanner(){
      try {
        this.$http.post('app/personalize_banners/create', {data: this.encrypt(this.banner).toString()},
          {headers:
            {"X-Device-ID" : this.getDeviceId(),
             "Authorization" : 'Bearer ' + this.getUserToken()}})
        .then(function(response){
          console.log(response)
          this.$router.push({name: 'root'})
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          console.log(response)
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    onFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      var name_field = ""+e.target.name
      this.url = URL.createObjectURL(files[0]);
      this.createImage(files[0], ""+e.target.name)
    },
    createImage (file, name_field) {
      var reader = new FileReader()
      var vm = this
      reader.readAsDataURL(file);
      reader.onload = function () {
        vm.banner.attributes.image = reader.result
        // vm.location.attributes.image = reader.result
      }
    },
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/views/personalize/Banners.vue